import isNullOrUndefined from '@/shared/utils/check-null-or-undefined';
import OrderBy from '../employees/entity/order-by.entity';

export default class SelectiveProcessFilter {
  cultureGrade: string;

  cultureGradePeriod: string[] = [];

  candidatesEmails: string;

  candidateName: string = '';

  jobs: string = '';

  orderBy!: OrderBy;

  jobStatus: string[];

  numericalReasoningGradePercentage: string = '';

  numericalReasoningGradePeriod: string[] = [];

  verbalReasoningGradePercentage: string = '';

  verbalReasoningGradePeriod: string[] = [];

  constructor(obj: any = {}) {
    this.cultureGrade = obj.cultureGrade || '';
    this.cultureGradePeriod = obj.cultureGradePeriod || [];
    this.candidatesEmails = obj.candidatesEmails || '';
    this.jobs = obj.jobs || '';
    this.jobStatus = obj.jobStatus || [];
    this.candidateName = obj.candidateName || '';
    this.numericalReasoningGradePercentage = obj.numericalReasoningGradePercentage || '';
    this.verbalReasoningGradePercentage = obj.verbalReasoningGradePercentage || '';
  }

  get hasJobs() {
    return !isNullOrUndefined(this.jobs) && this.jobs !== '';
  }

  get hasCandidatesEmails() {
    return !isNullOrUndefined(this.candidatesEmails) && this.candidatesEmails !== '';
  }

  get hasCandidateName() {
    return !isNullOrUndefined(this.candidateName) && this.candidateName !== '';
  }

  get hasCultureGradePeriod() {
    return this.cultureGradePeriod.length > 0;
  }

  get hasCultureGrade() {
    return this.cultureGrade !== undefined
      && this.cultureGrade !== null
      && this.cultureGrade !== '';
  }

  get hasJobStatus() {
    return this.jobStatus.length > 0;
  }
}
